/**
 * Runtime configuration that gets injected during deployment
 * Falls back to environment variables or defaults for local development
 */

declare global {
  interface Window {
    RUNTIME_CONFIG?: {
      API_URL?: string;
      COGNITO_USER_POOL_ID?: string;
      COGNITO_CLIENT_ID?: string;
      AWS_REGION?: string;
      S3_BUCKET?: string;
    };
  }
}

// Helper function to get config value with fallback
const getConfigValue = (key: keyof NonNullable<typeof window.RUNTIME_CONFIG>, envVar?: string, defaultValue?: string): string => {
  // First try runtime config (from deployed config.js)
  if (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG[key]) {
    return window.RUNTIME_CONFIG[key]!;
  }
  
  // Then try environment variable
  if (envVar && process.env[envVar]) {
    return process.env[envVar]!;
  }
  
  // Finally use default
  return defaultValue || '';
};

// Export configuration with runtime values
export const RUNTIME_CONFIG = {
  API_URL: getConfigValue('API_URL', 'REACT_APP_API_URL', 'http://localhost:5000/api'),
  COGNITO_USER_POOL_ID: getConfigValue('COGNITO_USER_POOL_ID', 'REACT_APP_COGNITO_USER_POOL_ID'),
  COGNITO_CLIENT_ID: getConfigValue('COGNITO_CLIENT_ID', 'REACT_APP_COGNITO_CLIENT_ID'),
  AWS_REGION: getConfigValue('AWS_REGION', 'REACT_APP_AWS_REGION', 'us-east-1'),
  S3_BUCKET: getConfigValue('S3_BUCKET', 'REACT_APP_S3_BUCKET'),
};

// Log configuration in development
if (process.env.NODE_ENV === 'development') {
  console.log('Runtime Configuration:', RUNTIME_CONFIG);
}